<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="确认"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="year">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.year"
            :open="yearPickerVisible"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="handleYearPickerOpenChange"
            @panelChange="handleYearSelect"
            @change="handleClearYear"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="年度总结报告" prop="file">
          <a-upload
            :file-list="fileList"
            :remove="handleFileRemove"
            :before-upload="beforeFileUpload"
            :disabled="disabeld"
            accept=".pdf"
          >
            <a-button :loading="uploading" :disabled="disabeld">
              <a-icon type="upload" /> 上传报告
            </a-button>
            <div class="upload-hint">注：可上传pdf格式的文件</div>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { postAction, putAction, fileUpdate } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

const MAX_FILE_COUNT = 1;
const SUPPORTED_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "video/mp4",
];

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      form: {
        applyId: "",
        year: "",
      },
      yearPickerVisible: false,
      rules: {
        year: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.year != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      zh_CN,
      locale,
      applyType: 1,
      mode: "", // 'add' or 'edit'
      title: "",
      fileList: [],
      uploading: false,
      disabeld: false,
    };
  },
  methods: {
    init(mode, record, taskId, detailId) {
      this.mode = mode;
      this.visible = true;
      this.resetForm();

      if (mode === "add") {
        this.title = "添加年度计划";
        this.form.applyId = record.id;
        this.form.year = new Date().getFullYear().toString();
      } else if (type == "edit") {
        this.title = "编辑年度计划";
        this.form = {
          applyId: record.applyId,
          id: record.id,
          year: record.year,
        };

        if (record.filePath) {
          this.fileList = [
            {
              path: record.filePath,
              name: record.fileName,
              uid: -1, // 使用负值避免冲突
            },
          ];
        }
      } else {
        this.disabeld = true;
        this.title = "查看年度计划";
        this.form = {
          applyId: record.applyId,
          id: record.id,
          year: record.year,
        };
        if (record.filePath) {
          this.fileList = [
            {
              path: record.filePath,
              name: record.fileName,
              uid: -1, // 使用负值避免冲突
            },
          ];
        }
      }
    },

    resetForm() {
      this.form = {
        applyId: "",
        year: "",
      };
      this.fileList = [];
    },

    handleFileRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    beforeFileUpload(file) {
      if (!this.isFileTypeSupported(file)) {
        this.$message.error("不支持的文件类型");
        return false;
      }

      if (this.fileList.length >= MAX_FILE_COUNT) {
        this.$message.error(`年度报告只能上传${MAX_FILE_COUNT}个文件`);
        return false;
      }

      this.uploadFile(file);
      return false;
    },

    isFileTypeSupported(file) {
      return SUPPORTED_FILE_TYPES.includes(file.type);
    },

    async uploadFile(file) {
      this.uploading = true;

      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("biz", "linxuan");

        const res = await fileUpdate(formData);
        if (res.code === 0) {
          this.$message.success("上传成功");
          this.fileList.push({
            path: res.message,
            name: file.name,
            uid: file.uid,
          });
        } else {
          this.$message.error(res.message || "上传失败");
        }
      } catch (error) {
        this.$message.error("上传过程中发生错误");
        console.error("Upload error:", error);
      } finally {
        this.uploading = false;
      }
    },

    handleCancel() {
      this.visible = false;
      this.resetForm();
    },

    async submit() {
      try {
        await this.$refs.formRef.validate();

        if (this.fileList.length === 0) {
          this.$message.error("请上传年度报告");
          return;
        }

        this.confirmLoading = true;
        
        const params = this.prepareSubmitData();
        this.$message.success(`${this.title}成功`);
          this.visible = false;
        this.$emit("addAnnualPlan", { record: params, type: this.mode });
        return;
        const apiUrl =
          this.mode === "add"
            ? "/lxbase/lxAnnualPlan/add"
            : "/lxbase/lxAnnualPlan/edit";

        const action = this.mode === "add" ? postAction : putAction;
        const res = await action(apiUrl, params);

        if (res.code == 200) {
          this.$message.success(`${this.title}成功`);
          this.visible = false;
          this.$emit("addAnnualPlan");
        } else {
          this.$message.error(res.message || `${this.title}失败`);
        }
      } catch (error) {
        console.error("Submit error:", error);
      } finally {
        this.confirmLoading = false;
      }
    },

    prepareSubmitData() {
      const params = { ...this.form, applyType: this.applyType };

      if (this.fileList.length > 0) {
        params.filePath = this.fileList[0].path;
        params.fileName = this.fileList[0].name;
      }

      if (typeof params.year === "object" && params.year !== "") {
        params.year = new Date(params.year).getFullYear().toString();
      }

      return params;
    },

    handleYearPickerOpenChange(open) {
      this.yearPickerVisible = open;
    },

    handleYearSelect(value) {
      this.form.year = moment(value).format("YYYY");
      this.yearPickerVisible = false;
      this.$refs.formRef.clearValidate("year");
    },

    handleClearYear() {
      this.form.year = "";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.upload-hint {
  margin-top: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
</style>